import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
var WsopNationalityRankingTableComponent = /** @class */ (function () {
    function WsopNationalityRankingTableComponent() {
        this.topList = [];
        this.bottomList = [];
    }
    Object.defineProperty(WsopNationalityRankingTableComponent.prototype, "rankingList", {
        set: function (list) {
            if (!list || 0 === list.length) {
                return;
            }
            this.bottomList = list.splice(3);
            this.topList = list;
        },
        enumerable: true,
        configurable: true
    });
    WsopNationalityRankingTableComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    return WsopNationalityRankingTableComponent;
}());
export { WsopNationalityRankingTableComponent };
